import type { FC } from "react";
import { useEffect } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import type { Contact } from "@jti/fe-common";
import { parsePhoneNumber } from "@jti/fe-common";
import { useSelector } from "@jti/store/reduxHooks";
import { selectAccountContact } from "@jti/store/selectors/selectAccountContact";
import { Telephone, useFormContext } from "@jti/ui";

import styles from "./PrefilledPhoneContact.module.scss";

const TELEPHONE_PREFIX = "editPhone";

type PrefilledPhoneContactProps = {
  telephone: Contact["telephone"];
  dataTestId?: string;
  isPhoneNumberRequired?: boolean;
};

export const PrefilledPhoneContact: FC<PrefilledPhoneContactProps> = ({
  telephone,
  dataTestId = "",
  isPhoneNumberRequired = true,
}) => {
  const config = useConfig();
  const { setValue, watch } = useFormContext();
  const accountContact = useSelector(selectAccountContact);

  const { value } = watch(`${TELEPHONE_PREFIX}.code`) || {};
  const phone = watch(`${TELEPHONE_PREFIX}.phone`);

  useEffect(() => {
    const [prefixPhoneNumber, nationalPhoneNumber] = parsePhoneNumber(
      config.TELEPHONE_CODES_LIST,
      telephone || accountContact?.telephone
    );

    if (nationalPhoneNumber) {
      setValue(`${TELEPHONE_PREFIX}.code`, {
        label: prefixPhoneNumber,
        value: prefixPhoneNumber,
      });
      setValue(`${TELEPHONE_PREFIX}.phone`, nationalPhoneNumber);
    }
  }, []);

  useEffect(() => {
    if (value && phone) {
      setValue(`shippingContact.telephone`, `${value}${phone}`);
    }
  }, [value, phone, setValue]);

  return (
    <div className={styles.prefilledPhoneContact} data-testid={dataTestId}>
      <Telephone
        isWithoutDropdown={false}
        fieldName={(name) => `${TELEPHONE_PREFIX}.${name}`}
        isRequired={isPhoneNumberRequired}
      />
    </div>
  );
};
